import type {
  Feature,
  Point,
  GeoJsonProperties,
  LineString,
  MultiLineString,
  MultiPoint,
} from 'geojson';
import { isNullObject } from '@/utils';
// get the latitude and longitude array from the wkt
export function getLatlonArray(path: string): any {
  if (!path) {
    return null;
  }
  // step 1: convert path string to geoJson object
  function convertWktToGeoJson(path: string): Feature {
    const geoJson = JSON.parse(path);
    return geoJson;
  }

  // decode type 'Point' geoJson object
  function decode1DgeoJsonObj(obj: Point) {
    const res: Latlon[] = [
      {
        latitude: obj.coordinates[1],
        longitude: obj.coordinates[0],
      },
    ];
    return res;
  }

  // decode type 'LineString' geoJson object
  function decode2DgeoJsonObj(obj: LineString | MultiPoint) {
    const res: Latlon[] = [];
    for (const item of obj.coordinates) {
      const latLon: Latlon = {
        latitude: item[1],
        longitude: item[0],
      };
      res.push(latLon);
    }
    return res;
  }

  // decode type 'MultiLineString' geoJson object
  function decode3DgeoJsonObj(obj: MultiLineString) {
    const res: Latlon[][] = [];
    obj.coordinates.map((line, index) => {
      const tempLine: Latlon[] = [];
      line.map((item, index) => {
        const latLon: Latlon = {
          latitude: item[1],
          longitude: item[0],
        };
        tempLine.push(latLon);
      });
      res.push(tempLine);
    });
    return res;
  }

  // step 2: convert geoJson's coordinates to Latlon objects array
  function geoJsonToLatlonObj(geoJson: Feature): {
    path: Latlon[] | Latlon[][];
    properties: GeoJsonProperties;
    coordinates: any;
    geometryType: string;
  } {
    let result: any = {};

    if (!isNullObject(geoJson.geometry)) {
      switch (geoJson.geometry.type) {
        case 'LineString':
          result = {
            path: [...decode2DgeoJsonObj(geoJson.geometry)],
            properties: geoJson.properties ?? {},
            coordinates: geoJson.geometry.coordinates,
            geometryType: geoJson.geometry.type,
          };
          break;
        case 'MultiLineString':
          result = {
            path: [...decode3DgeoJsonObj(geoJson.geometry)],
            properties: geoJson.properties ?? {},
            coordinates: geoJson.geometry.coordinates,
            geometryType: geoJson.geometry.type,
          };
          break;
        case 'MultiPoint':
          result = {
            path: [...decode2DgeoJsonObj(geoJson.geometry)],
            properties: geoJson.properties ?? {},
            coordinates: geoJson.geometry.coordinates,
            geometryType: geoJson.geometry.type,
          };
          break;
        case 'Point':
          result = {
            path: [...decode1DgeoJsonObj(geoJson.geometry)],
            properties: geoJson.properties ?? {},
            coordinates: geoJson.geometry.coordinates,
            geometryType: geoJson.geometry.type,
          };
      }
    }
    return result;
  }

  const geoJson = convertWktToGeoJson(path);

  const latLonObj = geoJson && geoJsonToLatlonObj(geoJson);
  return latLonObj;
}
